import React from "react";
import "../assets/scss/transfer.scss";

interface IEmptyData {
    color?: string;
    className?: string
}

const EmptyData: React.FC<IEmptyData> = ({ color, className }) => {
    return (
        <div className={`empty-data ${className}`} style={color ? { color } : {}}>
            <i className="mdi mdi-inbox" />

            <h4 style={color ? { color } : {}}>Nenhum dado encontrado</h4>
        </div>
    );
};

export default EmptyData;
